import {
  Box,
  createStyles,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { colors, DefaultButton } from 'design-system';
// Redux Related
import { connect, ConnectedProps } from 'react-redux';
import { clearEmissionPaymentError } from 'src/store/emissionPolicy/actions';

const useStyles = makeStyles(() =>
  createStyles({
    errorContainer: {
      marginTop: 50,
      display: 'flex',
      flexDirection: 'column',
      gap: '2rem',
      justifyContent: 'center',
      alignItems: 'center',
      paddingInline: '1rem',
    },
    fontTitle: {
      fontSize: 19,
      lineHeight: '24px',
      fontWeight: 900,
      letterSpacing: '.5px',
      maxWidth: '380px',
      width: '100%',
    },
    fontSubtitle: {
      fontSize: 15,
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '.1px',
      color: colors.abbey,
      maxWidth: '380px',
      width: '100%',
    },
    backButton: {
      width: '100%',
      maxWidth: '335px',
    },
    whatsappButton: {
      color: colors.bright_turquoise,
      fontWeight: 700,
      verticalAlign: 'bottom',
      '&:hover': {
        cursor: 'pointer',
      },
    },
    textWhatsApp: {
      marginBottom: '1rem',
    },
  }),
);

export const PaymentErrorLayout = ({
  clearEmissionErrorAction,
  messasgeDescription = 'verifica la información de tu tarjeta',
}: Props): JSX.Element => {
  const classes = useStyles();

  return (
    <div className={classes.errorContainer}>
      <Typography align="center" className={classes.fontTitle}>
        Lo sentimos, no se pudo completar la transacción.
      </Typography>
      <Typography align="center" className={classes.fontSubtitle}>
        Por favor, <strong>{messasgeDescription}</strong> y vuelve a intentarlo.
      </Typography>
      <Grid item xs={12}>
        <Grid container justifyContent="center">
          <img
            alt="error"
            src="/svg/error_payment_img.svg"
            data-testid="layout-img"
          />
        </Grid>
      </Grid>
      <div className={classes.backButton}>
        <DefaultButton
          id="sales-web-inspection-back"
          data-testid="back-button"
          fullWidth
          onClick={clearEmissionErrorAction}
        >
          regresar
        </DefaultButton>
      </div>
      <Typography
        align="center"
        className={`${classes.fontSubtitle} ${classes.textWhatsApp}`}
      >
        Si el error persiste, escríbenos al{' '}
        <Box
          component="span"
          className={classes.whatsappButton}
          onClick={(): Window | null =>
            window.open(`https://wa.me/50625032772`)
          }
          id="sales-web-inspection-whatsapp-button"
          data-testid="whatsapp-button"
        >
          WhatsApp (506)2503-2772
        </Box>{' '}
        o contacta a tu corredor de seguros.
      </Typography>
    </div>
  );
};

const reduxActions = {
  clearEmissionErrorAction: clearEmissionPaymentError,
};

const connector = connect(null, reduxActions);

type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
  messasgeDescription?: string;
}

export default connector(PaymentErrorLayout);
